import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountSelect", "companySelect"]
  static values = { url: String }

  fetchCompanies(event) {
    const accountId = event.target.value
    const currentCompanyId = this.companySelectTarget.value
    
    // Build URL with parameters
    const url = new URL(this.urlValue, window.location.origin)
    if (accountId) {
      url.searchParams.append("account_id", accountId)
    }
    if (currentCompanyId) {
      url.searchParams.append("company_id", currentCompanyId)
    }
    
    // Fetch companies via Turbo Stream
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
